export const FORM_NAMES = {
  addOrganization: 'addOrganization',
  addPractitioner: 'addPractitioner',
  addPatient: 'addPatient',
  editPatientChangePass: 'editPatientChangePass',
  editDeviceStatus: 'editDeviceStatus',
  changePassword: 'changePassword',
  detailedEPReport: 'detailedEPReport',
  deviceStatusPicker: 'deviceStatusPicker',
  editPatient: 'editPatient',
  feedback: 'feedback',
  login: 'login',
  filterPatients: 'filterPatients',
  filterReports: 'filterReports',
  notificationsSetting: 'notificationsSetting',
  transmissionReportSummary: 'transmissionReportSummary',
  uploadCardioReport: 'uploadCardioReport',
  uploadTachyReport: 'uploadTachyReport',
};

export const PASSWORD_LENGHT_MIN = 9;
export const TREATMENT_LENGTH_MAX = 100;

// TODO: uncomment when gitlab will be fixed
// export const PASSWORD_REGEX = new RegExp(`^(?=.*[0-9])(?=.*[a-zA-Z])\\w{${PASSWORD_LENGHT_MIN},}$`);
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-zA-Z])\w{9,}$/;

export const PHONE_REGEX = /^(\+\d[ ]\(\d{3}\)[ ]\d{3}[ ]\d{4})|(\(\d{3}\)[ ]\d{3}[ ]\d{4})$/;

export const DETAILED_EP_REPORT_FORM_FIELDS = [
  'leadsPresent',
  'percentAtrialPacing',
  'percentVentricularPacing',

  'anyVentricularArrhythmiasDetected',
  'anyVentricularArrhythmiasDetectedDate',
  'anyVentricularArrhythmiasDetectedRate',
  'anyVentricularArrhythmiasDetectedTreatment',

  'anyAtrialArrhythmiasDetected',
  'anyAtrialArrhythmiasDetectedDate',
  'anyAtrialArrhythmiasDetectedRate',
  'anyAtrialArrhythmiasDetectedTimeLength',

  'device_status_notes', // patient instructions
  'device_status_recommendations', // device Report Findings
  'comments',
];

export const ATRIAL_DEPENDENT_FIELD_VALUES = [
  'anyAtrialArrhythmiasDetectedDate',
  'anyAtrialArrhythmiasDetectedRate',
  'anyAtrialArrhythmiasDetectedTimeLength',
];

export const VENTRICULAR_DEPENDENT_FIELD_VALUES = [
  'anyVentricularArrhythmiasDetectedDate',
  'anyVentricularArrhythmiasDetectedRate',
  'anyVentricularArrhythmiasDetectedTreatment',
];

export const EDIT_DEVICE_INFO_FORM_FIELDS = [
  'alert',
  'pacing',
  'shock',
  'batteryLife',
  'shocksDate',
];
